export default function ManageInvitesViewController(
  $scope,
  $rootScope,
  $q,
  $filter,
  $stateParams,
  $uibModal,
  $log,
  manageInvitesRepository,
  RoleService,
  securityGroupsService,
  gettextCatalog,
) {
  'ngInject';

  $scope.successFlag = false;
  $scope.successText = '';
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.onLoadErrorFlag = false;
  $scope.onLoadErrorText = '';
  $scope.showGroups = false;
  $scope.setAll = {};
  $scope.roleModel = {
    data: {},
    count: 0,
  };
  $scope.editRoleModel = {
    data: {},
    count: 0,
  };
  $scope.groupModel = {
    data: {},
    count: 0,
  };
  $scope.editGroupModel = {
    data: {},
    count: 0,
  };
  $scope.loading = true;
  $scope.sending = false;
  var currentUser = $rootScope.currentUser;

  //Sorting
  $scope.search = {
    query: {
      role: '',
      group: '',
    },
  };
  $scope.rolePredicate = 'name';
  $scope.groupPredicate = 'name';
  $scope.roleReverse = false;
  $scope.groupReverse = false;
  var orderBy = $filter('orderBy');

  //Sort filteredRolePolicies
  $scope.orderRoles = function (predicate, rev, filtered = false) {
    $scope.rolePredicate = predicate;
    if (rev) $scope.roleReverse = $scope.rolePredicate === predicate ? !$scope.roleReverse : false;

    angular.forEach($scope.filteredRoles, function (role) {
      role[predicate] = role[predicate];
    });
    $scope.filteredRoles = orderBy($scope.filteredRoles, $scope.rolePredicate, $scope.roleReverse);
    $scope.displayRolesByPage();
    GTM_RolesChanged(filtered ? 'inviteRolesFiltered' : 'inviteRolesOrderChanged');
  };

  //Sort filteredDataPoints
  $scope.orderGroups = function (predicate, rev, filtered = false) {
    $scope.groupPredicate = predicate;
    if (rev)
      $scope.groupReverse = $scope.groupPredicate === predicate ? !$scope.groupReverse : false;

    angular.forEach($scope.filteredGroups, function (group) {
      group[predicate] = group[predicate];
    });
    $scope.filteredGroups = orderBy(
      $scope.filteredGroups,
      $scope.groupPredicate,
      $scope.groupReverse,
    );
    $scope.displayGroupsByPage();
    GTM_GroupsChanged(filtered ? 'inviteGroupsFiltered' : 'inviteGroupsOrderChanged');
  };

  //Pagination
  $scope.current = {
    roles: {
      page: 1,
    },
    groups: {
      page: 1,
    },
  };
  $scope.itemsPerPage = 8;
  $scope.maxSize = 1;

  //displayDataPointsByPage() is used to set the legnth of paging needed for filteredDataPoints.
  $scope.displayRolesByPage = function () {
    $scope.totalRoles = $scope.filteredRoles.length;
    var begin = ($scope.current.roles.page - 1) * $scope.itemsPerPage;
    var end = begin + $scope.itemsPerPage;
    $scope.rolesByPage = $scope.filteredRoles.slice(begin, end);
  };

  //displayRolePoliciesByPage() is used to set the legnth of paging needed for filteredRolePolicies.
  $scope.displayGroupsByPage = function () {
    $scope.totalGroups = $scope.filteredGroups.length;
    var begin = ($scope.current.groups.page - 1) * $scope.itemsPerPage;
    var end = begin + $scope.itemsPerPage;
    $scope.groupsByPage = $scope.filteredGroups.slice(begin, end);
  };

  //Calls displayDataPointsByPage(), everytime the the user changes the page.
  $scope.rolePageChanged = function () {
    $scope.displayRolesByPage();
    GTM_RolesChanged('inviteRolesPageChanged');
  };

  //Calls displayRolePoliciesByPage(), everytime the the user changes the page.
  $scope.groupPageChanged = function () {
    $scope.displayGroupsByPage();
    GTM_GroupsChanged('inviteGroupsPageChanged');
  };

  //applyFilter() searches the dataPoints[] for anything matching the search input.
  $scope.applyRoleFilter = function () {
    $scope.filteredRoles = $filter('filter')($scope.editRoles, {
      name: $scope.search.query.role,
    });
    $scope.orderRoles($scope.rolePredicate, false);
  };

  //applyPoliciesFilter() searches the rolePolicies[] for anything matching the search input.
  $scope.applyGroupFilter = function () {
    $scope.filteredGroups = $filter('filter')($scope.editGroups, {
      name: $scope.search.query.group,
    });
    $scope.orderGroups($scope.groupPredicate, false);
  };

  var init = function () {
    if ($stateParams.userEmail) {
      $scope.email = $stateParams.userEmail;
      manageInvitesRepository.getInviteByEmail($scope.email).then(
        function (invites) {
          $scope.invite = invites.data;

          $scope.$emit('$viewContentLoaded'); //breadcrumbs fix

          initRolesandGroups().then(
            function (response) {
              $scope.loading = false;
            },
            function (errorMsg) {
              $scope.loading = false;
              $scope.onLoadErrorText = errorMsg;
              $scope.onLoadErrorFlag = true;
            },
          );
        },
        function (error) {
          var errorMsg = gettextCatalog.getString(
            'An error occurred while retrieving invite information',
          );
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg =
                error.data.message +
                ' ' +
                (error.status.toString() + ' - ' + error.statusText.toString());
            } else {
              errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
          $scope.loading = false;
        },
      );
    } else {
      $scope.onLoadErrorFlag = true;
      $scope.onLoadErrorText = gettextCatalog.getString(
        'Could not load page: no recipient email provided.',
      );
      $scope.loading = false;
    }
  };

  var initRolesandGroups = function () {
    var defer = $q.defer();
    RoleService.getRoles().then(
      function onSuccess(response) {
        $scope.roles = response.data.slice();

        for (var i = 0; i < $scope.roles.length; i++) {
          for (var j = 0; j < $scope.invite.roles.length; j++) {
            if ($scope.roles[i].id === $scope.invite.roles[j]) {
              $scope.roles[i]._selected = true;
              $scope.invite.roles[j] = $scope.roles[i];
              $scope.roleModel.data[$scope.roles[i].id] = $scope.roles[i];
              $scope.roleModel.count++;
              break;
            }
          }
        }
        $scope.editRoles = angular.copy($scope.roles);
        $scope.filteredRoles = $scope.editRoles.slice();
        $scope.applyRoleFilter();
        $scope.editRoleModel = angular.copy($scope.roleModel);
        if (!$scope.showGroups) {
          defer.resolve();
        } else {
          return securityGroupsService.getAllSecurityGroups().then(
            function (response) {
              $scope.groups = response.data.data.slice();
              for (var i = 0; i < $scope.groups.length; i++) {
                for (var j = 0; j < $scope.invite.groups.length; j++) {
                  if ($scope.groups[i].id === $scope.invite.groups[j]) {
                    $scope.groups[i]._selected = true;
                    $scope.invite.groups[j] = $scope.groups[i];
                    $scope.groupModel.data[$scope.groups[i].id] = $scope.groups[i];
                    $scope.groupModel.count++;
                    break;
                  }
                }
              }
              $scope.editGroups = angular.copy($scope.groups);
              $scope.filteredGroups = $scope.editGroups.slice();
              $scope.applyGroupFilter();
              $scope.editGroupModel = angular.copy($scope.groupModel);
              if ($scope.groupModel.count == 0 && currentUser.securityMode !== 'Open') {
                //if user is discretionary and doesn't belong to a group (ie. no results when querying for groups), don't let them edit an invite
                defer.reject(
                  gettextCatalog.getString(
                    'Cannot edit an invite if not belonging to a security group.',
                  ),
                );
              }
              defer.resolve();
            },
            function (error) {
              var errorMsg = gettextCatalog.getString(
                'An error occurred while retrieving group information',
              );
              if (error.data || error.status) {
                if (error.data.message) {
                  errorMsg =
                    error.data.message +
                    ' ' +
                    (error.status.toString() + ' - ' + error.statusText.toString());
                } else {
                  errorMsg +=
                    ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
                }
              } else {
                errorMsg += gettextCatalog.getString('. Cannot assign groups at this time.');
              }
              defer.reject(errorMsg);
            },
          );
        }
      },
      function (error) {
        var errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving role information',
        );
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        defer.reject(errorMsg);
      },
    );
    return defer.promise;
  };

  //cancel a invite
  $scope.cancelInvite = function () {
    $scope.resetFlags();
    var modalInstance = $uibModal.open({
      animation: true,
      template: require('./revoke-modal/_revoke.modal.html'),
      controller: 'ManageInviteViewRevokeModalController',
      backdropClass: 'tr-invite-revoke-dismiss',
      resolve: {
        invite: function () {
          return $scope.invite;
        },
      },
      size: 'md',
    });

    modalInstance.result.then(
      function () {
        //show invite as being cancelled
        $scope.invite.status = gettextCatalog.getString('revoked');
        $scope.invite.revoked = {
          at: Date.now(),
          by: currentUser.email,
        };
        $scope.isEditing = false;
        $scope.successText = gettextCatalog.getString('Invite revoked successfully.');
        $scope.successFlag = true;
      },
      function () {
        $log.info(
          gettextCatalog.getString('Modal dismissed at: {{date}}', {
            date: new Date(),
          }),
        );
      },
    );
  };

  $scope.editButtonPressed = function () {
    $scope.resetFlags();
    if (!$scope.isEditing) {
      $scope.setAll = {};
      $scope.editRoles = angular.copy($scope.roles);
      $scope.filteredRoles = $scope.editRoles.slice();
      $scope.applyRoleFilter();
      $scope.editRoleModel = angular.copy($scope.roleModel);
      if ($scope.editGroups) {
        $scope.editGroups = angular.copy($scope.groups);
        $scope.filteredGroups = $scope.editGroups.slice();
        $scope.applyGroupFilter();
        $scope.editGroupModel = angular.copy($scope.groupModel);
      }
    }
  };

  $scope.roleSelected = function (role, model, selectingAll = false) {
    if (role._selected) {
      model.data[role.id] = role;
      model.count++;
    } else {
      delete model.data[role.id];
      model.count--;
    }

    if (!selectingAll) {
      GTM_RolesChanged(role._selected ? 'inviteRoleSelected' : 'inviteRoleDeselected');
    }
  };

  $scope.groupSelected = function (group, model, selectingAll = false) {
    if (group._selected) {
      model.data[group.id] = group;
      model.count++;
    } else {
      delete model.data[group.id];
      model.count--;
    }
    if (!selectingAll) {
      GTM_GroupsChanged(group._selected ? 'inviteGroupSelected' : 'inviteGroupDeselected');
    }
  };

  $scope.checkAllRoles = function () {
    for (var i = 0; i < $scope.editRoles.length; i++) {
      $scope.editRoles[i]._selected = $scope.setAll.roles;
      $scope.roleSelected($scope.editRoles[i], $scope.editRoleModel, true);
    }
    GTM_RolesChanged($scope.setAll.roles ? 'inviteRoleAllSelected' : 'inviteRoleAllDeselected');
  };

  $scope.checkAllGroups = function () {
    for (var i = 0; i < $scope.editGroups.length; i++) {
      $scope.editGroups[i]._selected = $scope.setAll.groups;
      $scope.groupSelected($scope.editGroups[i], $scope.editGroupModel, true);
    }
    GTM_GroupsChanged($scope.setAll.groups ? 'inviteGroupAllSelected' : 'inviteGroupAllDeselected');
  };

  $scope.saveButtonPressed = function () {
    if ($scope.editDisabled()) {
      return;
    }
    $scope.sending = true;
    $scope.resetFlags();
    var roleIds = [];
    var groupIds = [];
    for (var key in $scope.editRoleModel.data) {
      roleIds.push(key);
    }
    for (var key in $scope.editGroupModel.data) {
      groupIds.push(key);
    }
    var data = {
      roles: roleIds,
      groups: groupIds,
    };
    //save the updated roles and groups information
    manageInvitesRepository.updateInvite($stateParams.userEmail, data).then(
      function (response) {
        $scope.invite.roles = angular.copy($scope.editRoleModel.data);
        $scope.invite.groups = angular.copy($scope.editGroupModel.data);
        $scope.roles = angular.copy($scope.editRoles);
        $scope.groups = angular.copy($scope.editGroups);
        $scope.roleModel = angular.copy($scope.editRoleModel);
        $scope.groupModel = angular.copy($scope.editGroupModel);
        $scope.successFlag = true;
        $scope.successText = gettextCatalog.getString('Invite edited successfully.');
        $scope.isEditing = false;
        $scope.sending = false;
      },
      function (error) {
        var errorMsg = gettextCatalog.getString('An error occurred while updating the invite.');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorFlag = true;
        $scope.errorText = errorMsg;
        $scope.sending = false;
      },
    );
  };

  $scope.resetFlags = function () {
    $scope.successFlag = false;
    $scope.errorFlag = false;
  };

  $scope.editDisabled = function () {
    return (
      !(
        $scope.editRoleModel.count > 0 &&
        (!$scope.groupsRequired || $scope.editGroupModel.count > 0)
      ) || $scope.sending
    );
  };

  $scope.typeOf = function (item) {
    return typeof item;
  };

  if (currentUser) {
    if (currentUser.account.securityMode !== 'Open') {
      //only allow groups to be selected if the account is discretionary
      $scope.showGroups = true;
      if (currentUser.securityMode !== 'Open') {
        //if the user is discretionary, they must select at least one group
        $scope.groupsRequired = true;
      }
    }
    init();
  }

  $rootScope.$watch('currentUser', function (newVal, oldVal) {
    if (newVal && typeof oldVal === 'undefined') {
      currentUser = $rootScope.currentUser;
      if (currentUser.account.securityMode !== 'Open') {
        //only allow groups to be selected if the account is discretionary
        $scope.showGroups = true;
        if (currentUser.securityMode !== 'Open') {
          //if the user is discretionary, they must select at least one group
          $scope.groupsRequired = true;
        }
      }
      init();
    }
  });

  function GTM_RolesChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.roles.length,
        totalFiltered: $scope.filteredRoles.length,
        totalSelected: $scope.roleModel.count,
        sortDirection: $scope.roleReverse ? 'descending' : 'ascending',
        pageNumber: $scope.current.roles.page,
      },
    });
  }

  function GTM_GroupsChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.groups.length,
        totalFiltered: $scope.filteredGroups.length,
        totalSelected: $scope.groupModel.count,
        sortDirection: $scope.groupReverse ? 'descending' : 'ascending',
        pageNumber: $scope.current.groups.page,
      },
    });
  }
}
